import React, { useEffect, useState } from 'react';

import { PatientDetails } from '../../components/common/patientDetails';

import {
	removePatientById,
	clearData,
	pendingDispenseRemovingPageNumber
} from '../../services/slices/dispense/patientPendingList';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import { onhandleConfirmDelivery } from '../../utils/helper/deliveriesHelper';

import { PharmacistConfirmationModal } from '../../components/common/routeConfirmation';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import { fetchPatientPendingList } from '../../services/apis/dispense/patientPendingList';
import { useCustomStates } from '../../hooks/useCustomStates';
import useDeliveredRxHistory from '../../hooks/useDeliveredRxHistory';

import { DispenseRxData } from '../../components/common/dispenseRxData';
import { handleToggleRXData } from '../../utils/helper/helper';
import { PendingDispenseDeliveredByAnotherDriverAblyHelper } from '../../utils/helper/ablyDeliveredDispenseByOthers';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearSelectedPharmacistID } from '../../services/slices/auth/selectedPharmacist';

import { PharmacistSelection } from '../../components/common/pharmacistSelection';
import {
	InstoreDeliveryAssignmentAlert,
	InstoreDeliveryStockDecisionModal,
} from '../../components/common/instoreDeliveryContinuation';
import InstoreUnassignedHandover from '../../components/common/InstoreUnassignedHandover';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';

import * as Messages from '../../components/common/AllConfirmationMessages'
import * as routeNames from '../../routes/routeName'
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';

import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'

import PageNotFound from '../notFound/pageNotFound';

const PendingDispense = () => {

	const dispatch = Hooks.useCustomDispatch();
	const navigate = Hooks.useCustomNavigate();

	const { pharmacyId, driverID, pharmacyInspectionMode, selectedPharmacistID } = useAuthSelector()
	const { patientPendingListResponse, validateReturnedPatchesResponse, pharmacistDetail } = useAllSelector();

	const { comment,
		setComment,

		cordinate,
		setCordinate,

		isRefused,
		setIsRefused,

		openIndex,
		setOpenIndex,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		loading,
		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		apiCallMade,
		setApiCallMade,

		showToast,
		setShowToast,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		isTransferRequest,
		setIsTransferRequest,

		loadMore,
		setLoadMore,

		delveryDoneByAnotherDriver,
		setDeliveryDoneByAnotherDriver,

		patientId,
		setPatientID,

		pId,
		setPId,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,

		showPharmacistConfirmation,
		setShowPharmacistConfirmation,

		pendingDeliveryData,
		setPendingDeliveryData,

		pendingDeliveryIndex,
		setPendingDeliveryIndex

	} = useCustomStates()

	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([]);
	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false);
	const [flexiProofImages, setFlexiProofImages] = useState({});
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({});
	const [showStockDecisionModal, setShowStockDecisionModal] = useState(false);
	const [pendingStockDecision, setPendingStockDecision] = useState(null);

	// Today's already delivered Rxs for the open card. Display only: they are
	// rendered separately and never enter patients_win_rx_data, the selection
	// or the confirm-delivery payload.
	const openPatient = openIndex != null ? patientPendingListResponse?.data?.[openIndex] : null;
	const deliveredHistoryRx = useDeliveredRxHistory({
		patientId: openPatient?.id,
		pharmacyId,
		pendingRxData: openPatient?.patients_win_rx_data,
		enabled: openPatient != null,
	});

	// Get Selected Pharmacist Name
	const getSelectedPharmacistName = () => {
		if (selectedPharmacistID && pharmacistDetail?.length) {
			const selectedPharmacist = pharmacistDetail.find(
				pharmacist => Number(pharmacist.id) === Number(selectedPharmacistID) || pharmacist.id == selectedPharmacistID
			);
			return selectedPharmacist?.name || '';
		}
		return '';
	};

	const handleDropdownToggle = (index, data) => {
		if (openIndex !== index && data?.patients_win_rx_data?.length) {
			setSelectedDeliverRxIds(data.patients_win_rx_data.map((r) => r.id).filter(Boolean));
		}
		setConsultation(null)
		setNewRxCounsellingValues([])
		setSelectedDoses({})
		handleToggleRXData(
			index,
			data,
			openIndex,
			setOpenIndex,
			dispatch,
			clearSelectedPharmacistID,
			setSignatureErrors,
			setShowData,
			RemoveAllPatchesId,
			setPatientSignature,
			setShowComment,
			setShowPatientSignature,
			setShowPharmacistSignature,
			setPharmacistSignature,
			setComment,
			setIsPatientVerified,
			setPId,
			pharmacyId
		)
	}

	useEffect(() => {
		if (pharmacyId) {
			setLoading(true)
			if (!apiCallMade) {
				dispatch(clearData())
				dispatch(pendingDispenseRemovingPageNumber())
				dispatch(fetchPatientPendingList({
					page: 1,
					pharmacy_id: pharmacyId,
					setLoading: setLoading
				}))
				setApiCallMade(true)
			}
		}
		return () => { }
	}, [])

	const handleConfirmDelivery = (patientData, index) => {
		// if (!isRefused && (!patientSignature || patientSignature[0] == null)) {
		// 	setSignatureErrors(prevState => ({ ...prevState, patientSign: '1px solid red' }));
		// 	return;
		// }
		setPendingDeliveryData(patientData);
		setPendingDeliveryIndex(index);
		// Only show Confirm Pharmacist popup when there is a pharmacist signature on the pad
		if (pharmacistSignature) {
			setShowPharmacistConfirmation(true);
		} else {
			// No pharmacist sign – continue delivery without showing the modal
			requestStockDecisionOrProceed(patientData, index);
			setPendingDeliveryData(null);
			setPendingDeliveryIndex(null);
		}
	}

	const proceedWithDelivery = () => {
		setShowPharmacistConfirmation(false);
		if (pendingDeliveryData && pendingDeliveryIndex !== null) {
			requestStockDecisionOrProceed(pendingDeliveryData, pendingDeliveryIndex);
		}
		setPendingDeliveryData(null);
		setPendingDeliveryIndex(null);
	}

	const processDelivery = (patientData, index, deliveryStockDisposition = null, deliveryStockSignature = null) => {
		onhandleConfirmDelivery(patientData,
			index,
			pharmacyId,
			selectedPharmacistID,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			setOpenIndex,
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'pending_dispense',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			{},
			{},
			null,
			isPatientVerified,
			selectedDeliverRxIds,
			deliveryStockDisposition,
			deliveryStockSignature
		);
	}

	const requestStockDecisionOrProceed = (patientData, index) => {
		if (patientData?.instore_delivery_assignment?.assigned) {
			setPendingStockDecision({ patientData, index });
			setShowStockDecisionModal(true);
			return;
		}

		processDelivery(patientData, index);
	}

	const handlePharmacistConfirmationCancel = () => {
		setShowPharmacistConfirmation(false);
		setPharmacistSignature(null);
		setPendingDeliveryData(null);
		setPendingDeliveryIndex(null);
	}

	const handleStockDecision = (deliveryStockDisposition, deliveryStockSignature = null) => {
		if (pendingStockDecision?.patientData && pendingStockDecision?.index !== null) {
			processDelivery(pendingStockDecision.patientData, pendingStockDecision.index, deliveryStockDisposition, deliveryStockSignature);
		}
		setShowStockDecisionModal(false);
		setPendingStockDecision(null);
	}

	const handleStockDecisionCancel = () => {
		setShowStockDecisionModal(false);
		setPendingStockDecision(null);
	}

	const fetchMoreData = () => {
		if (patientPendingListResponse?.currentPage < patientPendingListResponse?.totalPages) {
			setLoadMore(true)
			dispatch(fetchPatientPendingList({
				page: patientPendingListResponse?.currentPage + 1,
				pharmacy_id: pharmacyId,
				setLoading: setLoading,
				setLoadMore: setLoadMore
			}))
		}
	}

	return (
		<>
			{pharmacyId ? <>
				{patientPendingListResponse?.data?.length > 0 &&
					<InfiniteScroll
						dataLength={patientPendingListResponse?.data?.length}
						next={fetchMoreData}
						hasMore={patientPendingListResponse?.currentPage <= patientPendingListResponse?.totalPages}
					/>
				}

				<div className="app-wrapper flex justify-center">
					{/* <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden"> */}

					{/* <div className="app-screen no-shades w-full  lg:w-full md:w-6/12 sm:w-6/12 h-full  overflow-x-hidden "> */}
					<div className="app-screen no-shades w-full h-full  overflow-x-hidden ">

						<div className="relative p-4" >
							<div className="card bg-white p-4 rounded-lg shadow-sm">
								<div className="flex items-center justify-between gap-3">
									<div>
										<Common.TopBar pharmacyId={pharmacyId} />
									</div>

									<div className='flex items-center justify-center btnnn pt-4' onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)} >
										<Icons.HomeIcon />
									</div>
								</div>
							</div>

							<div className="title-row my-2" >
								<h1 className="text-xl font-bold">Today's Pending Dispense</h1>
							</div>

							<div className="flex gap-3 mb-3">
								<SearchBox pharmacyId={pharmacyId} />
							</div>

							<div className="routes-list">
								{(patientPendingListResponse?.loading && loading) ?
									<div className='flex justify-center h-96'>
										<Loading.LoadingView />
									</div> :

									patientPendingListResponse?.error !== null ?
										<div className='flex  justify-center pb-4 mb-4 h-96'>
											<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
										</div> :

										(patientPendingListResponse?.data?.length === 0 && !patientPendingListResponse?.loading) ?
											<p className='flex  justify-center pb-4 pt-3 h-96'>No more deliveries for today.</p>
											:

											patientPendingListResponse?.data?.map((data, index) => {
												const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
												return (
												<React.Fragment key={index}>
													<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
														<PatientDetails
															data={data}
															patientImg={data.profile_image}
															totalRxData={data?.patients_win_rx_data?.length}
															index={index}
															openIndex={openIndex}
															onDropdownToggle={handleDropdownToggle}
															headerAction={<InstoreUnassignedHandover patient={data} selectedRxIds={selectedDeliverRxIds} isActive={openIndex === index} />}
														>
															<>
																<InstoreDeliveryAssignmentAlert assignment={data?.instore_delivery_assignment} />
																<DispenseRxData
																	rxData={data?.patients_win_rx_data}
																	signatureErrors={signatureErrors}
																	type="new_rx"
																	newRxCounsellingValues={newRxCounsellingValues}
																	setNewRxCounsellingValues={setNewRxCounsellingValues}
																	patientData={data}
																	selectedDoses={selectedDoses}
																	setSelectedDoses={setSelectedDoses}
																	flexiProofImages={flexiProofImages}
																	setFlexiProofImages={setFlexiProofImages}
																	copayPaymentOptions={copayPaymentOptions}
																	setCopayPaymentOptions={setCopayPaymentOptions}
																	selectedDeliverRxIds={selectedDeliverRxIds}
																	setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																	isActiveDeliverRxCard={openIndex === index}
																	deliverRxSelectionEnabled={data?.delivery_status !== 'delivered'}
																/>

																{openIndex === index && openPatient?.id === data?.id && deliveredHistoryRx.length > 0 && (
																	<DispenseRxData
																		rxData={deliveredHistoryRx}
																		selectedDoses={{}}
																		readOnly
																	/>
																)}

																{patientId !== data?.id ? <>
																	<PharmacistSelection
																		signatureErrors={signatureErrors}
																		setSignatureErrors={setSignatureErrors}
																		setShowData={setShowData}
																	/>
																	{showData &&
																		<React.Fragment>
																			<div className="mb-3">
																				<Common.DeliveryConsultationDropdown consultation={consultation}
																					setConsultation={setConsultation} />
																			</div>
																					<div className="flex flex-col md:flex-row gap-3 mb-3 items-start">
																				<Common.PatientSignature patientSignature={patientSignature}
																					setPatientSignature={setPatientSignature}
																					showPatientSignature={showPatientSignature}
																					setShowPatientSignature={setShowPatientSignature}
																					isRefused={isRefused}
																					setIsRefused={setIsRefused}
																					signatureErrors={signatureErrors}
																					setSignatureErrors={setSignatureErrors}
																					covid19={covid19}
																					setCovid19={setCovid19}
																					rxData={data?.patients_win_rx_data}
																				/>
																				<Common.PharmacistSignature
																					pharmacistSignature={pharmacistSignature}
																					setPharmacistSignature={setPharmacistSignature}
																					showPharmacistSignature={showPharmacistSignature}
																					setShowPharmacistSignature={setShowPharmacistSignature}
																					signatureErrors={signatureErrors}
																					setSignatureErrors={setSignatureErrors}
																					selectedPharmacistID={selectedPharmacistID}
																					pharmacistDetail={pharmacistDetail}
																				/>
																			</div>
																			<Common.Comment showComment={showComment}
																				setShowComment={setShowComment}
																				setComment={setComment} comment={comment} />
																			<Common.PatientVerified
																				isPatientVerified={isPatientVerified}
																				setIsPatientVerified={setIsPatientVerified}
																			/>
																		</React.Fragment>
																	}
																	{selectedPharmacistID && (
																	<div className="flex items-center gap-3">
																		{showData ?
																			validateReturnedPatchesResponse?.loading ? null :
																				showFlexiConfirmation ? (
																					<button className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md" onClick={() => window.location.reload()}>
																						Reload
																					</button>
																				) : (
																					<button
																						className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																						style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																						disabled={noRxSelected}
																						onClick={() => { if (!noRxSelected) handleConfirmDelivery(data, index); }}
																					>
																						Continue
																					</button>
																				)
																			: (
																				<button
																					className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																					style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																					disabled={noRxSelected}
																					onClick={() => {
																						if (noRxSelected) return;
																						setShowData(true);
																						setTimeout(() => {
																							const windowHeight = window.innerHeight;
																							const scrollAmount = windowHeight / 2;
																							window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																						}, 100);
																					}}
																				>
																					Deliver
																				</button>
																			)
																		}
																	</div>
																	)}
																</> : null}
															</>
														</PatientDetails>
													</div>
												</React.Fragment>
											);
											})}
							</div>

							{loadMore && <div className='flex mb-2'>
								<div className="loaderss"></div>
							</div>}

						</div>

					</div>
				</div>

				{showErrorToast && <Messages.DeliveryErrorMessages setShowErrorToast={setShowErrorToast} message={typeof showErrorToast === 'string' ? showErrorToast : undefined} />}
				{showSuccessToast && <Messages.DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}

			<PharmacistConfirmationModal
				showModal={showPharmacistConfirmation}
				setShowModal={setShowPharmacistConfirmation}
				pharmacistName={getSelectedPharmacistName()}
				onConfirm={proceedWithDelivery}
				onCancel={handlePharmacistConfirmationCancel}
			/>

			<InstoreDeliveryStockDecisionModal
				showModal={showStockDecisionModal}
				patientName={[pendingStockDecision?.patientData?.first_name, pendingStockDecision?.patientData?.last_name].filter(Boolean).join(' ')}
				signingAsName={getSelectedPharmacistName()}
				onTakeNow={(signature) => handleStockDecision('take_now', signature)}
				onReturnEndOfDay={() => handleStockDecision('return_end_of_day')}
				onCancel={handleStockDecisionCancel}
			/>

			<PendingDispenseDeliveredByAnotherDriverAblyHelper
					apiKey={apiKey}
					deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
					pharmacyId={pharmacyId}
					driverID={driverID}
					pId={pId}
					routeName={routeNames}
					setPatientID={setPatientID}
					setDeliveryDoneByAnotherDriver={setDeliveryDoneByAnotherDriver}
					dispatch={dispatch}
					removePatientById={removePatientById}
					setOpenIndex={setOpenIndex}
					setPId={setPId}
					setCordinate={setCordinate}
				/>

			</>
				: <PageNotFound />}
		</>
	)
}

export default PendingDispense
